// extracted by mini-css-extract-plugin
export default {"footerDescWrapper":"_FooterDesc_footerDescWrapper__G6kts"};